import { ControlSettingsAdjust } from '@fs/zion-icon/dist/cjs/icons'
import { QuickGlanceActions, QuickGlanceOverlay, Row, Button } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import DmcPlaceStandards from '../../common/DmcPlaceStandards'

export default function UserProfileSearchFiltersButtonAndOverlay({
  country,
  stateOrProvince,
  onFilterChange,
  ...overlay
}) {
  const { t } = useTranslation()

  return (
    <>
      <Button Icon={ControlSettingsAdjust} onClick={overlay.handleClick}>
        {t('filters.filterBy', 'Filter By')}
      </Button>
      <QuickGlanceOverlay {...overlay} title={t('filters.advancedFilter', 'Advanced Filter')}>
        <>
          <Row>
            <DmcPlaceStandards
              label={t('country', 'Country')}
              selectedItem={country}
              setSelectedItem={(place) => onFilterChange('country', place)}
              placeTypes={['Country']}
              editable
            />
          </Row>
          <Row>
            <DmcPlaceStandards
              label={t('user.userProfile.stateOrProvince', 'State or Province')}
              selectedItem={stateOrProvince}
              setSelectedItem={(place) => onFilterChange('stateOrProvince', place)}
              placeTypes={['State', 'Province']}
              editable
            />
          </Row>
        </>

        <QuickGlanceActions>
          <Button emphasis="medium" onClick={overlay.close}>
            {t('action.done', 'Done')}
          </Button>
        </QuickGlanceActions>
      </QuickGlanceOverlay>
    </>
  )
}
